<div class="colorBox" [ngClass]="{ 'hex-input-validation': showHexadecimalError }">
  <input type="color" class="colorBox-color" [(ngModel)]="mainColor" [style.background]="mainColor" (ngModelChange)="updateMainColor($event); writeValue($event)" />
  <input type="text" class="colorBox-text" [ngModel]="mainColor" (ngModelChange)="updateMainColor($event); writeValue($event)" />
</div>
